import React, { useEffect, useState } from 'react';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import {
  Container,
  Header,
  Wrapper,
  StatusPill,
  Pill,
  CardFrame,
  EditButton,
  CardContent,
  Footer,
  CardSimpleItemContainer,
  CardSimpleItemTitle,
  CardSimpleItemLabel,
  Divider,
  DescriptionCardContainer,
  DescriptionCardTitle,
  DescriptionCardText,
  ImgFrame,
  CardDividerContainer,
  CardWrapper,
  LoaderWrapper,
  CardEmptyContainer,
  ContainerOverFlow
} from './styles';
import { site } from '@panel/commons/helpers';
import { getDevice } from '@panel/commons/helpers';
import Edition from '../../../assets/icons/edition.svg';
// import Info from '../../../assets/icons/info.svg';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { useQuery } from '@panel/commons/hooks';
import { getUrlPosting } from '@panel/avisos/helpers/getUrlPosting';
import { genericFormatAmount } from '@panel/commons/helpers/formatAmount';
import Loader from '@panel/commons/lib/SimpleLoader';
import { sendCustomTrackingInfo } from '@panel/commons';
import useDetectOverflow from '@panel/commons/hooks/useDetectOverflow';
import { getCurrencySymbolByCode } from '@panel/commons/helpers/currenciesBySite';
import { previewConfig } from './previewConfig';
import { PreviewOperations, PreviewSelectors } from '../../ducks/preview';
import { Button, ButtonOutline, ButtonWithoutBackground } from '../commons/Button';
import { StepperOperations } from '../../ducks/stepper';
import { getStepperState } from '../../ducks/stepper/selectors';
import QualityCard from './QualityCard';
import { sendEditionTrackingInfo, setStepTitle } from '../../utils/adaptStepDataAndSendTrackinInfo';
import BannerInfo from '../BannerInfo';
import defaultImg from '../../../assets/img/defaultImg.svg';
import { lastStepGuardHelper } from '../../utils/lastStepGuardHelper';
import useBannerLogic from '../../hooks/useBannerLogic';
import { getRealEstateSubTypeName, getRealEstateTypeName } from '../../utils/realEstateTypesByPortal';
import { getLocationFields } from './locationUtils';
import { transformValue } from '../../utils/numberFormatHelper';
import { getStepMainSelectors, StepMainOperations } from '../../ducks/propertyType';
import { isPortalWithPropertySubType } from '../../utils/sitesValidations';

const EditionView = () => {
  const device = getDevice();
  const [postingId] = useQuery(useLocation(), ['postingId']);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    postingData,
    loadingPostingData,
    errorPostingData,
    qualityData,
    loadingQualityData,
    errorQualityData
  } = useSelector(PreviewSelectors.getPreviewState);
  const [cardsData, setCardsData] = useState(null);
  const history = useHistory();
  const stepperState = useSelector(getStepperState);
  const { setSnackAction } = StepperOperations;
  const isOnlineOrNearEnd = postingData?.status === 'ONLINE' || postingData?.status === 'NEAR_END';
  const isMobile = device === 'mobile';
  const { showBannerOldReppro } = useBannerLogic(false, false, false, true, isMobile);
  const { propertySubTypeOptions } = useSelector(getStepMainSelectors);

  useEffect(() => {
    if (postingId && !errorPostingData) {
      const comesToUpdateSuccessefully = Cookies.get('updateSuccessfully');
      // se necesita agregar un timeout para darle tiempo a que se actualicen los datos en la DB sino el get trae datos viejos
      if (comesToUpdateSuccessefully === 'true') {
        dispatch(PreviewOperations.setLoading(true));
        setTimeout(() => {
          dispatch(PreviewOperations.getPostingData(postingId));
        }, 2000);
      } else {
        dispatch(PreviewOperations.getPostingData(postingId));
      }
    } else {
      history.push('/avisos');
    }
    dispatch(StepperOperations.getPostingLastStep(postingId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingId, errorPostingData]);

  useEffect(() => {
    // Pedimos la data de calidad
    if (postingId && !errorQualityData) {
      dispatch(PreviewOperations.getQualityData(postingId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingId, errorQualityData]);

  useEffect(() => {
    if (postingData && stepperState.lastStep) {
      if (postingData.status === 'DRAFT') {
        //redirecciono al ultimo paso cargado si es un draft
        lastStepGuardHelper(stepperState.lastStep, postingId, history, ['isDraftFromPanel=true']);
      }
    }
  }, [history, postingData, postingId, stepperState.lastStep]);

  useEffect(() => {
    // Traemos los subtipos de propiedad si es que existen para saber si habilitamos el boton de volver
    if (postingData?.realEstateTypeId && isPortalWithPropertySubType) {
      dispatch(StepMainOperations.getSubPropertyType(postingData.realEstateTypeId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingData?.realEstateTypeId]);

  // Efecto para mostrar los snackbars en base a las cookies
  useEffect(() => {
    const comesToUpdateSuccessefully = Cookies.get('updateSuccessfully');
    // con esta cookie sabemos que venimos de republicar desde el paso de publicacion
    const tryRepublishFromPublishStep = Cookies.get('tryRepublishFromPublishStep');
    if (comesToUpdateSuccessefully === 'true') {
      dispatch(
        setSnackAction({
          action: 'updatedSuccessfully',
          result: 'SUCCESS',
          component: t(
            `professionalPubli.edition.snack.updateSuccessfully${tryRepublishFromPublishStep ? '.fromPublishStep' : ''}`
          ),
          section: 'Publicador profesionales - Vista Edicion'
        })
      );
      Cookies.remove('updateSuccessfully');
      Cookies.remove('tryRepublishFromPublishStep');
    }
    const leaveStepWithoutSaveChanges = Cookies.get('leaveStepWithoutSaveChanges');
    if (leaveStepWithoutSaveChanges === 'true') {
      dispatch(
        setSnackAction({
          action: 'leaveStepWithoutSaveChanges',
          result: 'INFO',
          component: t('professionalPubli.edition.leaveStepWithoutSaveSnack'),
          section: 'Publicador profesionales - Vista Edicion'
        })
      );
      Cookies.remove('leaveStepWithoutSaveChanges');
    }

    return () => {
      // Saneamiento del state que dispara el Snackbar:
      dispatch(setSnackAction({ action: '', result: '' }));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // cuando tengo los datos del aviso armo los componentes de cada card
    if (postingData) {
      const data = previewConfig.map(item => {
        if (item.id === 'quality' && qualityData) {
          return {
            ...item,
            content: <QualityCard data={qualityData} device={device} />
          };
        }
        if (item.id === 'main') {
          // si no tiene subtipo de propiedad no se puede editar el paso 1
          if (propertySubTypeOptions?.length === 0 || !isPortalWithPropertySubType) {
            item.pathEdition = null;
          } else {
            item.pathEdition = '/main';
          }
          return {
            ...item,
            content: <RealEstateCard data={postingData} device={device} />
          };
        }
        if (item.id === 'location') {
          return {
            ...item,
            content: <LocationCard data={postingData} device={device} />
          };
        }
        if (item.id === 'price') {
          return {
            ...item,
            content: <PriceCard data={postingData} device={device} />
          };
        }
        if (item.id === 'publication') {
          return {
            ...item,
            content: <PublicationCard data={postingData} device={device} isOnlineOrNearEnd={isOnlineOrNearEnd} />
          };
        }
        if (item.id === 'description') {
          return {
            ...item,
            content: <DescriptionCard data={postingData} device={device} />
          };
        }
        if (item.id === 'multimedia') {
          return {
            ...item,
            content: <MultimediaCard data={postingData} device={device} />
          };
        }
        if (item.id === 'features') {
          return {
            ...item,
            content: <MainFeaturesCard data={postingData} device={device} />
          };
        }
        if (item.id === 'extras') {
          return {
            ...item,
            content: <ExtrasCard data={postingData} device={device} />
          };
        }
        return item;
      });
      setCardsData(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingData, qualityData, propertySubTypeOptions]);

  const getLinkToPostingUrl = urlPosting => `../${t('panel.url.property')}/${getUrlPosting(urlPosting, postingId)}`;

  const handleOnGoToPosting = () => {
    sendEditionTrackingInfo(postingData, 'Ver aviso', postingId);
    const link = getLinkToPostingUrl(postingData.urlPosting);
    window.open(link, '_blank');
  };

  const handleOnGoToPublishStep = () => {
    sendEditionTrackingInfo(postingData, 'Republicar', postingId);
    // como el flujo para ir al paso 8 una vez publicado es por la vista de edicion defino si necesita o no republicar o publicar segun status
    handleGoToStep('/publish', null, !isOnlineOrNearEnd);
  };

  const handleOnGoToPanel = () => {
    sendEditionTrackingInfo(postingData, 'Ir a mis avisos', postingId);
    history.push('/avisos');
  };

  const handleGoToStep = (path, step_number = null, isRepublishEnabled = false) => {
    if (step_number) {
      sendCustomTrackingInfo({
        event: 'edit_publication',
        content_group: 'Publicador',
        step: setStepTitle(step_number)
      });
    }
    const finalPath = `/publicador-profesionales${path}?postingId=${postingId}&isEdition=true&republish=${isRepublishEnabled}`;
    history.push(finalPath);
  };

  return (
    <>
      <Container device={device}>
        {showBannerOldReppro && (
          <BannerInfo dataPubli='edition-view-banner-info' isEdition={'isEdition'} postingId={postingId} />
        )}
        <Wrapper device={device} data-publi='publicador-wrapper-edition'>
          <Header>
            {t('professionalPubli.edition.header.title')}
            {postingData?.status && (
              <StatusPill status={postingData?.status} data-publi='edition-status'>
                <Pill status={postingData?.status} data-publi='edition-status-color' />
                {t(`panel.posting.status.${postingData?.status}`)}
              </StatusPill>
            )}
          </Header>
          {cardsData?.map(item => {
            return (
              <Card
                key={item.id}
                data={item}
                device={device}
                handleGoToStep={handleGoToStep}
                isRepublishEnabled={item.id === 'publication'}
              />
            );
          })}
          {!isOnlineOrNearEnd ? (
            <Footer isMobile={device === 'mobile'}>
              <ButtonWithoutBackground data-publi='goToPosting' height={isMobile ? '48px' : '40px'}>
                <span onClick={handleOnGoToPosting}>{t('professionalPubli.edition.buttons.goToPosting')}</span>
              </ButtonWithoutBackground>
              <ButtonOutline data-publi='goToPanel' onClick={handleOnGoToPanel} height={isMobile ? '48px' : '40px'}>
                {t('professionalPubli.edition.buttons.goToPanel')}
              </ButtonOutline>
              <Button data-publi='publish' height={isMobile ? '48px' : '40px'} onClick={handleOnGoToPublishStep}>
                {t('professionalPubli.edition.buttons.publish')}
              </Button>
            </Footer>
          ) : (
            <Footer isMobile={device === 'mobile'} needChangeToRow={isMobile}>
              <ButtonOutline
                onClick={handleOnGoToPosting}
                width={isMobile && isOnlineOrNearEnd ? '47%' : 'unset'}
                height={isMobile ? '48px' : '40px'}
                data-publi='goToPosting'
              >
                {t('professionalPubli.edition.buttons.goToPosting')}
              </ButtonOutline>
              <Button
                width={isMobile && isOnlineOrNearEnd ? '47%' : 'unset'}
                height={isMobile ? '48px' : '40px'}
                onClick={handleOnGoToPanel}
                data-publi='goToPanel'
              >
                {t(`professionalPubli.edition.buttons.goToPanel${isMobile && site.isBrasil ? '.mobile' : ''}`)}
              </Button>
            </Footer>
          )}
        </Wrapper>
        {(loadingPostingData || loadingQualityData) && (
          <LoaderWrapper>
            <Loader width='96px' height='96px' />
          </LoaderWrapper>
        )}
      </Container>
    </>
  );
};

const Card = ({ data, handleGoToStep, device, isRepublishEnabled = false }) => {
  const { t } = useTranslation();
  if (data.content === null) return <></>;
  return (
    <CardFrame device={device} data-publi={`edition-${data.id}-card`}>
      {data.content}
      {data.pathEdition && (
        <EditButton data-publi={`edition-${data.id}-button-edit`} device={device}>
          <span onClick={() => handleGoToStep(data.pathEdition, data.step_number, isRepublishEnabled)}>
            {t('professionalPubli.edition.edit')}
            <img width={'12px'} style={{ marginBottom: '-2px' }} src={Edition} alt='icon edition' />
          </span>
        </EditButton>
      )}
    </CardFrame>
  );
};

const RealEstateCard = ({ data }) => {
  const { t } = useTranslation();
  if (!data?.realEstateTypeId) {
    return (
      <CardContent data-publi='realEstateCard-emptyState'>{t('professionalPubli.edition.emptyState')}</CardContent>
    );
  }
  return (
    <CardContent>
      <CardSimpleItem dataPubli='realEstateTypeId' title={getRealEstateTypeName(data?.realEstateTypeId)} />
      {!!getRealEstateSubTypeName(data?.realEstateSubTypeId) && (
        <>
          <Divider />
          <CardSimpleItem
            dataPubli='realEstateSubTypeId'
            title={getRealEstateSubTypeName(data?.realEstateSubTypeId)}
            withDivider={false}
          />
        </>
      )}
      {data?.operationTypeIds.map((item, index) => {
        return (
          <React.Fragment key={index}>
            <Divider />
            <CardSimpleItem
              key={index}
              dataPubli={`operationType-${index}`}
              title={t(`professionalPubli.operationType.${item}`)}
              withDivider={false}
            />
          </React.Fragment>
        );
      })}
    </CardContent>
  );
};

const MultimediaCard = ({ data, device }) => {
  const { t } = useTranslation();
  const isMobile = device === 'mobile';
  const keys = data?.multimedia ? Object.keys(data?.multimedia) : [];
  const filteredKeys = keys.filter(key => key !== 'miniatureUrl' && data.multimedia[key]);
  return (
    <CardContent orientation={'row'} alignItems='center'>
      <ImgFrame
        data-publi='multimedia-miniature'
        url={data?.multimedia?.miniatureUrl || defaultImg}
        isMobile={isMobile}
      />
      <CardWrapper isMobile={isMobile} needCenterMobile={keys.length === 0 && isMobile}>
        {(filteredKeys.length === 0 || data?.multimedia?.pictureCount === 0) && (
          <CardEmptyContainer>
            <CardSimpleItem
              isEmpty
              emptyLabel={t('professionalPubli.edition.card.empty')}
              label={t(`professionalPubli.edition.pictureCount`)}
              isMobile={isMobile}
              dataPubli='multimedia-emptyState'
            />
          </CardEmptyContainer>
        )}
        {filteredKeys.map((id, index) => {
          return (
            <CardDividerContainer key={index} isMobile={isMobile}>
              <CardSimpleItem
                key={index}
                title={data.multimedia[id]}
                label={t(`professionalPubli.edition.${id}`)}
                isMobile={isMobile}
                dataPubli={`multimedia-${id}`}
              />
              {index !== filteredKeys.length - 1 && !isMobile && <Divider />}
            </CardDividerContainer>
          );
        })}
      </CardWrapper>
    </CardContent>
  );
};

const MainFeaturesCard = ({ data, device }) => {
  const { t } = useTranslation();
  const isMobile = device === 'mobile';
  const notMandatoryFeatures = ['CFT7', 'CFT4'];
  if (!data?.mainFeatures || Object.keys(data?.mainFeatures).length === 0) {
    return (
      <CardContent>
        <CardDividerContainer isMobile={isMobile}>
          <CardSimpleItem
            isEmpty
            emptyLabel={t('professionalPubli.edition.card.empty')}
            label={t(`professionalPubli.features.CFT100`)}
            isMobile={isMobile}
            dataPubli='mainFeatures-emptyState'
          />
        </CardDividerContainer>
      </CardContent>
    );
  }
  // filtro los features que no tienen valor y que no sean obligatorias: CFT7 y CFT4
  const filteredFeatures = Object.keys(data?.mainFeatures).filter(item => {
    // CFT5 es un feature que puede tener valor 0 valido ( antiguedad )
    const isNotEmptyValue = data?.mainFeatures[item] !== '0' || item === 'CFT5';
    return data?.mainFeatures[item] !== null && isNotEmptyValue && !notMandatoryFeatures.includes(item);
  });

  const getTitle = currentTitle => {
    if (Number(currentTitle) === 0) return t('professionalPubli.features.antiquity.op2');
    if (Number(currentTitle) === -1) return t('professionalPubli.features.antiquity.op1');
    return currentTitle;
  };

  const formatAreaAmounts = data => {
    const formatAmounts = { ...data };
    const keys = Object.keys(formatAmounts);
    keys.forEach(key => {
      if (key === 'CFT100' || key === 'CFT101') {
        const splitedData = formatAmounts[key].split(' ');
        formatAmounts[key] = transformValue(Number(splitedData[0])) + ' ' + splitedData[1];
      } else if (key !== 'CFT5') {
        formatAmounts[key] = transformValue(formatAmounts[key]);
      }
    });
    return formatAmounts;
  };

  const formatedData = formatAreaAmounts(data?.mainFeatures);

  return (
    <CardContent orientation={isMobile ? 'column' : 'row'}>
      {filteredFeatures.map((item, index) => {
        return (
          <CardDividerContainer key={index} isMobile={isMobile}>
            <CardSimpleItem
              key={index}
              title={getTitle(formatedData[item])}
              label={t(`professionalPubli.features.${item}`)}
              isMobile={isMobile}
              dataPubli={item}
            />
            {index !== filteredFeatures.length - 1 && !isMobile && <Divider />}
          </CardDividerContainer>
        );
      })}
    </CardContent>
  );
};

const ExtrasCard = ({ data, device }) => {
  const { t } = useTranslation();
  const MAX_ITEMS_VISIBLES = 3;
  const isMobile = device === 'mobile';
  const visibles = data?.extraFeatures
    ?.slice() // copia para no mutar el original
    .sort((a, b) => {
      // Ordenamos primero las caracateristicas tipo check (tienen el value === null)
      const aValue = a[Object.keys(a)[0]];
      const bValue = b[Object.keys(b)[0]];
      if (aValue === null && bValue !== null) return -1;
      if (aValue !== null && bValue === null) return 1;
      return 0;
    })
    .slice(0, MAX_ITEMS_VISIBLES);

  if (!data?.extraFeatures || data?.extraFeatures?.length === 0) {
    return (
      <CardContent>
        <CardSimpleItem
          isEmpty
          emptyLabel={t('professionalPubli.edition.noExtraFeatures')}
          isMobile={isMobile}
          dataPubli='extraFeatures-emptyState'
        />
      </CardContent>
    );
  }

  const getRestOfExtras = () => {
    const diff = data?.extraFeatures?.length - MAX_ITEMS_VISIBLES;
    return (
      <>
        <strong>+ {diff}</strong> {t(`professionalPubli.edition.features${diff > 1 ? '.plural' : ''}`)}
      </>
    );
  };

  return (
    <CardContent orientation={isMobile ? 'column' : 'row'} alignItems={!isMobile ? 'center' : 'flex-start'}>
      {data?.extraFeatures?.length === 0 && t('professionalPubli.edition.emptyState')}
      {visibles.map((item, index) => {
        const feature = Object.keys(item)[0];
        const featureLabel = typeof feature === 'string' ? feature : JSON.stringify(feature);
        let value = item?.[feature];
        if (value !== null && !isNaN(Number(value))) {
          value = transformValue(Number(value));
        }
        const displayValue = typeof value === 'object' && value !== null ? JSON.stringify(value) : value;
        const maxLength = () => {
          if (isMobile) return 55;
          if (device === 'tablet') return 13;
          return 18;
        };
        return (
          <CardDividerContainer key={index} isMobile={isMobile}>
            <CardSimpleItem
              title={value ? <TextWithTooltip text={displayValue} maxLength={maxLength()} device={device} /> : null}
              label={<TextWithTooltip text={featureLabel} maxLength={maxLength()} device={device} />}
              isMobile={isMobile}
              dataPubli={`extraFeature-${index}`}
            />
            {index !== 2 && index < visibles.length - 1 && !isMobile && <Divider />}
          </CardDividerContainer>
        );
      })}
      {data?.extraFeatures.length > MAX_ITEMS_VISIBLES && (
        <CardDividerContainer isMobile={isMobile}>
          {!isMobile && <Divider />}
          <CardSimpleItem title={getRestOfExtras()} isMobile={isMobile} dataPubli='restOfExtras' />
        </CardDividerContainer>
      )}
    </CardContent>
  );
};

const PriceCard = ({ data, device }) => {
  const { t } = useTranslation();
  const isMobile = device === 'mobile';
  const filteredData = data?.prices?.filter(item => item.operationTypeId !== 'CFT6'); // filtro los gastos
  if (!data?.prices || filteredData.length === 0) {
    return (
      <CardContent>
        <CardSimpleItem
          isEmpty
          dataPubli='priceCard-emptystate'
          emptyLabel={t('professionalPubli.edition.emptyState')}
          isMobile={isMobile}
        />
      </CardContent>
    );
  }

  const getPriceTitle = item => {
    return (
      <CardContent>
        <strong>{getCurrencySymbolByCode(item.currency)}</strong>
        <TextWithTooltip
          text={genericFormatAmount(item.amount)}
          maxLength={device === 'tablet' ? 16 : 21}
          device={device}
        />
      </CardContent>
    );
  };

  const getPriceLabel = item => {
    if (item.operationTypeId === 'CFT6') {
      return t(`professionalPubli.price.expenses`);
    }
    return t(`professionalPubli.operationType.${item.operationTypeId}`);
  };

  return (
    <CardContent orientation={isMobile ? 'column' : 'row'}>
      {filteredData.map((item, index) => {
        if (item.operationTypeId === 'CFT6') {
          return null;
        }
        return (
          <CardDividerContainer key={index} isMobile={isMobile}>
            <CardSimpleItem
              key={index}
              title={getPriceTitle(item)}
              label={getPriceLabel(item)}
              isMobile={isMobile}
              dataPubli={`price-${index}`}
            />
            {index < filteredData.length - 1 && !isMobile && <Divider />}
          </CardDividerContainer>
        );
      })}
    </CardContent>
  );
};

const PublicationCard = ({ data, device, isOnlineOrNearEnd }) => {
  const { t } = useTranslation();
  const { publication } = data;
  const isMobile = device === 'mobile';
  const keys = Object.keys(publication || {});
  const filteredKeys = keys.filter(key => {
    return publication[key];
  });
  // si no hay datos de publicacion, muestro un item empty state del plan de publicacion
  if (filteredKeys.length === 0) {
    return (
      <CardContent orientation={isMobile ? 'column' : 'row'}>
        <CardDividerContainer isMobile={isMobile}>
          <CardSimpleItem
            isEmpty
            emptyLabel={t('professionalPubli.edition.card.empty')}
            label={t(`professionalPubli.edition.publicationPlan`)}
            isMobile={isMobile}
            dataPubli='publicationPlan-emptyState'
          />
        </CardDividerContainer>
      </CardContent>
    );
  }

  return (
    <CardContent orientation={isMobile ? 'column' : 'row'}>
      {filteredKeys?.map((item, index) => {
        if (item === 'publicationPlan' && (!publication.publicationPlan || !isOnlineOrNearEnd)) {
          // si el plan de publicacion no existe, muestro un item empty state
          return (
            <CardDividerContainer key={index} isMobile={isMobile}>
              <CardSimpleItem
                isEmpty
                emptyLabel={t('professionalPubli.edition.card.empty')}
                label={t(`professionalPubli.edition.publicationPlan`)}
                isMobile={isMobile}
                dataPubli='publicationPlan-emptyState-1'
              />
              {index < filteredKeys.length - 1 && !isMobile && <Divider />}
            </CardDividerContainer>
          );
        }
        return (
          <CardDividerContainer key={index} isMobile={isMobile}>
            <CardSimpleItem
              key={index}
              title={publication[item]}
              label={t(`professionalPubli.edition.${item}`)}
              isMobile={isMobile}
              dataPubli={item}
            />
            {index < filteredKeys.length - 1 && !isMobile && <Divider />}
          </CardDividerContainer>
        );
      })}
    </CardContent>
  );
};

const LocationCard = ({ data, device }) => {
  const { t } = useTranslation();
  const isMobile = device === 'mobile';
  const maxLength = isMobile ? 55 : 20;

  const { visibleFields } = getLocationFields(data, t);

  return (
    <CardContent orientation={isMobile ? 'column' : 'row'}>
      {visibleFields.map((field, index) => (
        <React.Fragment key={field.key}>
          <CardSimpleItem
            title={<TextWithTooltip text={field.value} maxLength={maxLength} device={device} />}
            isMobile={isMobile}
            isEmpty={false}
            emptyLabel={field.emptyLabel}
            dataPubli={field.key}
          />
          {!isMobile && index < visibleFields.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </CardContent>
  );
};

const DescriptionCard = ({ data, device }) => {
  const isMobile = device === 'mobile';
  const { title, description } = data;
  const { t } = useTranslation();
  const maxLength = () => {
    if (isMobile) return 116;
    if (device === 'tablet') return 60;
    return 70;
  };
  const slicedTitle = <TextWithTooltip text={title} maxLength={maxLength()} device={device} />;

  return (
    <CardContent>
      <DescriptionCardContainer>
        <DescriptionCardTitle isEmpty={!title || title === 'GENERIC_TITLE'} data-publi='description-title'>
          {title && title !== 'GENERIC_TITLE' ? slicedTitle : t('professionalPubli.edition.noTitle')}
        </DescriptionCardTitle>
        <DescriptionCardText
          isEmpty={!description || description === 'GENERIC_DESCRIPTION'}
          device={device}
          data-publi='description-text'
        >
          {description && description !== 'GENERIC_DESCRIPTION'
            ? description
            : t('professionalPubli.edition.noDescription')}
        </DescriptionCardText>
      </DescriptionCardContainer>
    </CardContent>
  );
};

const CardSimpleItem = ({
  title,
  label,
  withDivider,
  isMobile = false,
  isEmpty = false,
  emptyLabel = '',
  dataPubli = ''
}) => {
  return (
    <CardSimpleItemContainer withDivider={withDivider} isMobile={isMobile}>
      <CardSimpleItemTitle data-publi={`title-${dataPubli}`} isMobile={isMobile} isEmpty={isEmpty}>
        {isEmpty ? emptyLabel : title}
      </CardSimpleItemTitle>
      {label && (
        <CardSimpleItemLabel notDimmed={title === null} data-publi={`label-${dataPubli}`}>
          {label}
        </CardSimpleItemLabel>
      )}
    </CardSimpleItemContainer>
  );
};

const TextWithTooltip = ({ text, maxLength = 20, device }) => {
  const isMobile = device === 'mobile';
  const { labelRef, hasOverFlow } = useDetectOverflow();
  const showTooltip = text && (text.length > maxLength || hasOverFlow) & !isMobile;

  if (!text) return '';
  if (showTooltip) {
    return (
      <SimpleTooltip
        isMobile={device === 'tablet'}
        width='200px'
        height='fit-content'
        position='top-center'
        text={text}
        backgroundColor='#3c3834'
      >
        <ContainerOverFlow ref={labelRef}>{text.slice(0, maxLength) + '...'}</ContainerOverFlow>
      </SimpleTooltip>
    );
  }
  return (
    <ContainerOverFlow device={device} ref={labelRef}>
      {text}
    </ContainerOverFlow>
  );
};

export default EditionView;
